module.exports = __webpack_public_path__ + "8a381618863aa1b53fb0e9c878a7faf4.png";